<template>
	<div class="Register">
		<div class="Register-top content-bag">
			<div class="Register-content content-within">
				<div class="Register-form content-formter">
					<div class="Register-img"></div>
					<div class="tall-input">
						<el-form
							:model="ruleForm"
							:rules="rules"
							ref="ruleForm"
							class="demo-ruleForm"
						>
							<el-form-item prop="name">
								<i class="icon-user"></i>
								<el-input
									v-model="ruleForm.name"
									placeholder="姓名"
								></el-input>
							</el-form-item>
							<el-form-item prop="mobile">
								<i class="icon-user"></i>
								<el-input
									v-model="ruleForm.mobile"
									placeholder="电话"
								></el-input>
							</el-form-item>
							<el-form-item prop="captcha">
								<i class="icon-user"></i>
								<el-input
									v-model="ruleForm.captcha"
									placeholder="验证码"
									class="Verification"
									readonly autocomplete="off" onMouseDown="this.removeAttribute('readonly')"
								></el-input>
								<div class="Vderification" @click="sendVerify">
									{{ second === totalSecond ? '获取验证码' : second + '秒后发送' }}
								</div>
							</el-form-item>
							<el-form-item prop="pass">
								<i class="icon-user"></i>
								<el-input
									v-if="visible"
									type="password"
									v-model="ruleForm.pass"
									placeholder="8位及以上包含数字、大小写字母、特殊符号"
								>
									<i slot="suffix" title="显示密码" 
										class="iconfont icon-yanjingbi"
										style="cursor:pointer;margin-right:5px"
										@click="changePass('show')"
									></i>
								</el-input>
								<el-input
									v-else
									type="text"
									v-model="ruleForm.pass"
									placeholder="8位及以上包含数字、大小写字母、特殊符号"
								>
									<i slot="suffix" title="隐藏密码" 
										class="iconfont icon-yanjing"
										style="cursor:pointer;margin-right:5px"
										@click="changePass('hide')"
									></i>
								</el-input>
							</el-form-item>
							<el-form-item prop="checkPass">
								<i class="icon-user"></i>
								<el-input
									v-if="visible1"
									type="password"
									v-model="ruleForm.checkPass"
									placeholder="确认密码"
								>
									<i slot="suffix" title="显示密码" 
										class="iconfont icon-yanjingbi"
										style="cursor:pointer;margin-right:5px"
										@click="changePass1('show')"
									></i>
								</el-input>
								<el-input
									v-else
									type="text"
									v-model="ruleForm.checkPass"
									placeholder="确认密码"
								>
									<i slot="suffix" title="隐藏密码" 
										class="iconfont icon-yanjing"
										style="cursor:pointer;margin-right:5px"
										@click="changePass1('hide')"
									></i>
								</el-input>
							</el-form-item>
							<el-form-item prop="QQNumber">
								<el-input
									v-model="ruleForm.QQNumber"
									placeholder="QQ"
								></el-input>
							</el-form-item>
						</el-form>
						<!-- 登录 -->
						<div class="el-form-item" style="margin-bottom: 8px;">
							<div
								class="el-form-item__content"
								@click="submitForm('ruleForm')"
							>
								<div
									class="el-button is-center el-button--primary"
								>
									注册
								</div>
							</div>
							<div class="el-form-item__content">
								<router-link to="/login"
									>已有账号，立即登录</router-link
								>
							</div>
						</div>
						<div class="row-item" style="margin-bottom: 22px;">
							<el-checkbox v-model="radio" round></el-checkbox>
							<p
							style="font-size:14px;color:#606266;padding-left:10px">
							我已阅读并同意 <a @click="handleDialog">《{{ hyAgreement.chineseTitle }}》</a><a @click="handleDialog1">《{{ privacyAgreement.chineseTitle }}》</a>
							</p>
						</div>
						<!-- 注册 -->
						<!-- <div class="el-form-item" style="margin-bottom: 22px;">
                            <div class="el-form-item__content">
                                <span>已有账号？ </span>
                                <router-link to="/">立即登录</router-link>
                            </div>
                        </div>-->
					</div>
				</div>
			</div>
		</div>
		<el-dialog
			:title="hyAgreement.chineseTitle"
			:visible.sync="dialogVisible"
			width="50%"
			append-to-body
			top="4vh">
			<div v-html="hyAgreement.imageContent"></div>
		</el-dialog>
		<el-dialog
			:title="privacyAgreement.chineseTitle"
			:visible.sync="dialogVisible1"
			width="50%"
			append-to-body
			top="4vh">
			<div v-html="privacyAgreement.imageContent"></div>
		</el-dialog>
		<!-- 底部 -->
		<Lrheder class="header"></Lrheder>
	</div>
</template>

<script>
import Lrheder from './Lrheader'
import { ajaxPost, Baseurl } from '../../api/api/api'

export default {
	name: 'Register',
	data() {
		var mobile = (rule, value, callback) => {
			var ymobile = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/
			if (!value) {
				callback(new Error('请输入手机号'))
			} else if (!ymobile.test(value)) {
				callback(new Error('手机号格式不正确'))
			} else {
				callback()
			}
		}
		var validatePass = (rule, value, callback) => {
			// console.log(value)
			let str = /^(?![A-Za-z]+$)(?![A-Z0-9]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![A-Z\W_!@#$%^&*`~()-+=+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,16}$/
			// console.log(str.test(value))
			if (value === '') {
				callback(new Error('请输入密码'))
			} else if (!str.test(value)) {
				callback(
					new Error(
						'密码格式不正确(密码长度8-16,必须包含数字、大小写字母)'
					)
				)
			} else {
				if (this.ruleForm.checkPass !== '') {
					this.$refs.ruleForm.validateField('checkPass')
				}
				callback()
			}
		}
		var validatePass2 = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入确认密码'))
			} else if (value !== this.ruleForm.pass) {
				callback(new Error('两次输入密码不一致!'))
			} else {
				callback()
			}
		}
		var QQNumber = (rule, value, callback) => {
			var qqPattern = /^[1-9][0-9]{4,10}$/
			if (value === '') {
				callback(new Error('请输入QQ号码'))
			} else if (!qqPattern.test(value)) {
				callback(new Error('QQ格式不正确！'))
			} else {
				callback()
			}
		}
		return {
			visible: true,
			visible1: true,
			dialogVisible: false,
			dialogVisible1: false,
			radio: false,
			hyAgreement: '',
			privacyAgreement: '',
			// btnText: '发送验证码',
			// time: 0,
			totalSecond: 60, // 总秒数
			second: 60, // 当前秒数
			timer: null, // 定时器 id
			recCap: '',
			ruleForm: {
				mobile: '',
				captcha: '',
				pass: '',
				checkPass: '',
				name: '',
				QQNumber: '',
			},
			rules: {
				mobile: [
					{
						required: true,
						message: '请输入手机号',
						trigger: 'blur',
					},
					{ validator: mobile, trigger: 'blur' },
				],
				captcha: [
					{
						required: true,
						message: '请输入验证码',
						trigger: 'blur',
					},
				],
				pass: [
					{ required: true, message: '请输入密码', trigger: 'blur' },
					{ validator: validatePass, trigger: 'blur' },
				],
				checkPass: [
					{
						required: true,
						message: '请输入确认密码',
						trigger: 'blur',
					},
					{ validator: validatePass2, trigger: 'blur' },
				],
				name: [
					{ required: true, message: '请输入姓名', trigger: 'blur' },
					{
						min: 2,
						max: 5,
						message: '长度在 2 到 5 个字符',
						trigger: 'blur',
					},
				],
				QQNumber: [
					{
						required: true,
						message: '请输入QQ号码',
						trigger: 'blur',
					},
					{ validator: QQNumber, trigger: 'blur' },
				],
			},
		}
	},
	components: {
		Lrheder,
	},
	mounted() {},
	created() {
    	this.getJurisdictionInfo()
	},
	methods: {
		changePass(value) {
			this.visible = !(value === 'show')
		},
		changePass1(value) {
			this.visible1 = !(value === 'show')
		},
		handleDialog() {
			this.dialogVisible = true;
			this.getJurisdictionInfo()
		},
		handleDialog1() {
			this.dialogVisible1 = true;
			this.getJurisdictionInfo()
		},
		getJurisdictionInfo() {
			const API = Baseurl + 'guanwangManageController/getJurisdictionInfo'
			const paramsData = {
				id: 78
			}
			ajaxPost(API,paramsData)
				.then((res) => {
				if(res.data.code === 200) {
					this.hyAgreement = res.data.data.guanwangImages[0]
					this.privacyAgreement = res.data.data.guanwangImages[1]
				}
				})
		},
		sendVerify() {
			var reg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/
			if (this.ruleForm.mobile === '') {
				this.$message.error('请输入手机号')
			} else if (!reg.test(this.ruleForm.mobile)) {
				this.$message.error('手机号格式不正确')
			} else {
				// this.time = 60
				// this.disabled = true
				// this.timer()
				if (!this.timer && this.second === this.totalSecond) {
					// 开启倒计时
					this.timer = setInterval(() => {
						this.second--
						if (this.second <= 0) {
							clearInterval(this.timer) // 清除定时器
							this.timer = null // 重置定时器 id
							this.second = this.totalSecond // 归位
						}
					}, 1000)
					ajaxPost(Baseurl + 'userControllers/getCode', {
						telephone: this.ruleForm.mobile,
					}).then((res) => {
						// console.log(res);
						if (res.data.code == 200) {
							this.recCap = res.data.data
						}
					})
				}
				// console.log(2222);
				// this.$http
				//     .post(
				//         "/api/userControllers/getOneByName?telephone=" +
				//             this.ruleForm.mobile
				//     )
				//     .then(res => {
				//         if (res.data.code === 200) {
				//             this.recCap = res.data.data;
				//         }
				//     });
				// ajaxPost(Baseurl + 'userControllers/getCode', {
				// 	telephone: this.ruleForm.mobile,
				// }).then((res) => {
				// 	// console.log(res);
				// 	if (res.data.code == 200) {
				// 		this.recCap = res.data.data
				// 	}
				// })
			}
			// console.log(123123)
		},
		// timer() {
		// 	if (this.time > 0) {
		// 		this.time--
		// 		this.btnText = this.time + 's后'
		// 		setTimeout(this.timer, 1000)
		// 	} else {
		// 		this.time = 0
		// 		this.btnText = '发送验证码'
		// 		this.disabled = false
		// 	}
		// },
		submitForm(ruleForm) {
			this.$refs[ruleForm].validate((valid) => {
				if (valid) {
					if(this.radio == false) {
						this.$message.warning("请阅读并勾选用户协议")
					}
					const loading = this.$loading({
						lock: true,
						text: 'Loading',
						spinner: 'el-icon-loading',
						background: 'rgba(255, 255, 255, 0.7)',
					})
					// if (this.ruleForm.captcha != this.recCap) {
					// 	console.log(ruleForm.captcha)
					//     this.$message.error("验证码输入错误");
					// } else {
					ajaxPost(Baseurl + 'userControllers/register', {
						userName: this.ruleForm.name,
						password: this.ruleForm.pass,
						qq: this.ruleForm.QQNumber,
						telephone: this.ruleForm.mobile,
						code: this.ruleForm.captcha,
						passwords: this.ruleForm.checkPass,
					}).then((res) => {
						loading.close()
						if (res.data.code == 200) {
							this.$router.push('/')
						} else {
							this.$message.error(res.data.data)
						}
					})
					// this.$http
					//     .post(
					//         Baseurl +"userControllers/register?name=" +
					//             this.ruleForm.name +
					//             "&password=" +
					//             this.ruleForm.pass +
					//             "&qq=" +
					//             this.ruleForm.QQNumber +
					//             "&telephone=" +
					//             this.ruleForm.mobile +
					//             "&verificationCode=" +
					//             this.ruleForm.captcha +
					//             "&passwords=" +
					//             this.ruleForm.checkPass
					//     )
					//     .then(res => {
					//         if (res.data.code === "200") {
					//             this.$router.push("/");
					//         } else {
					//             this.$message.error(res.data.message);
					//         }
					//     })
					//     .catch(error => {
					//         console.log(error);
					//     });
					// }
				} else {
					return false
				}
			})
		},
	},
	destroyed() {
		clearInterval(this.timer)
	}
}
</script>

<style lang="scss">
.Register {
	width: 100%;
	height: 100%;
	display: block;
	.el-form-item__label {
		text-align: left;
	}
	// .el-form-item {
	//     margin-bottom: 18px;
	// }
	.tall-input {
		margin: 22px 30px;
		.el-form-item__content {
			line-height: 40px;
			text-align: center;
			position: relative;
			font-size: 14px;
			.el-input__inner {
				// color: #9e9e9e;
			}
			.icon-user:before {
				position: absolute;
				left: 0;
				z-index: 9999;
				content: '*';
				color: #f56c6c;
				margin-top: -2%;
			}
			.right {
				float: right;
				color: #2c559b;
			}
			a {
				color: #fe000e;
				text-decoration: underline;
				cursor: pointer;
			}
			.is-center {
				width: 100%;
				letter-spacing: 2px;
			}
			.el-button--primary {
				color: #fff;
				background-color: #194f7b;
				border-color: #194f7b;
			}
		}
		.row-item {
			display: flex;
			/* align-items: flex-end; */
			a {
				color: #194f7b;
				cursor: pointer;
			}
			.el-checkbox__inner {
				border-radius: 50%;
			}
		}
	}
	.Verification {
		float: left;
		width: 65%;
	}
	.Vderification {
		background-color: #194f7b;
		float: right;
		width: 25%;
		text-align: center;
		padding: 0 10px;
		border-radius: 4px;
		color: #fff;
	}
}
</style>
